import { ADD_PRODUCTS, CLEAR_PRODUCTS } from "../Action/productsAction";

const initialState = {
  products: [],
};

export const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PRODUCTS:
      return {
        ...state,
        products: action.payload,
      };
    case CLEAR_PRODUCTS:
      return {
        ...state,
        products: [],
      };
    default:
      return state;
  }
};


export default productsReducer;
